const common = require('./source/common');
const index = require('./source/index');
const apiCache = require('./source/apiCache');
const product = require('./source/product');
const supply = require('./source/supply');
const detailMobile = require('./source/detailMobile');
const areaMap = require('./source/areaMap');
const productMap = require('./source/productMap');
const pagination = require('./source/pagination');
const LoginDialog = require('./source/login').LoginDialog;

const demonstrate = require('./source/demonstrate');

$(function () {
  $.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
      options.xhrFields = {
          withCredentials: true
      }
  });
  common.init();
  window.loginDialog = new LoginDialog();
  // if (location.pathname.indexOf("/product/detail") != -1)
  {
    productMap.init();
    product.init();
  }
  // else if (location.pathname.indexOf("/product") != -1){
  //   product.init();
  // }
  // else if (location.pathname.indexOf("/area") != -1)
  {
    areaMap.init();
  }
  // else if (location.pathname.indexOf("/supply") != -1)
  {
    supply.init();
  }
  // else 
  {
    index.init();
  }
  detailMobile.init();
  apiCache.init();

  demonstrate.init();
});
